import { HStack } from '@chakra-ui/react'
import { FC } from 'react'

import useTools from '@hook/shared/use-tools'

import ModalHistoricoConfigFollowUp from '@component/FollowUpFornecedor/Config/Historico'
import ModalHistoricReabTimeline from '@component/Modules/Reab/HistoricTimeline'
import ModalHistoricPurchaseAlcadas from '@component/Parameterization/PurchaseAlcadas/Historic'
import ModalHistoricPurchaseCronograma from '@component/Parameterization/PurchaseCronograma/Historic'
import ModalHistoricPurchaseFerias from '@component/Parameterization/PurchaseFerias/Historic'
import ModalHistoricPurchaseTolerancia from '@component/Parameterization/PurchaseTolerancia/Historic'
import ModalHistoricPurchaseUser from '@component/Parameterization/PurchaseUser/Historic'
import ModalHistoricRouteReab from '@component/Parameterization/ReabRoute/Historic'
import ModalHistoricTypeVeichule from '@component/Parameterization/ReabTypeVeichule/Historic'

import ActionColumns from './Action/Columns'
import ActionExport from './Action/Export'
import ActionFollowUpFornecedorExport from './Action/Export/FollowUpFornecedorExport'
import ActionPurchaseCreateOrderSap from './Action/PurchaseCreateOrderSap'
import ActionPurchaseCreateOrderSapDistribuition from './Action/PurchaseCreateOrderSap-distribuition'
import ActionPurchaseCreateOrderSapReab from './Action/PurchaseCreateOrderSap-reab'
import ActionPurchaseCreateOrderSapSchedule from './Action/PurchaseCreateOrderSap-schedule'
import ActionPurchaseSuppliers from './Action/PurchaseSuppliers'
import ActionSapHistoric from './Action/SapHistoric'
import ActionCronogramaUpload from './Action/Upload/CronogramaUpload'
import ActionFeriasCargaUpload from './Action/Upload/FeriasCargaUpload'
import ActionFollowUpComentReabUpload from './Action/Upload/FollowUpComentReabUpload'
import ActionFollowUpComentUpload from './Action/Upload/FollowUpComentUpload'
import ActionFollowUpFornecedorImportUpload from './Action/Upload/FollowUpFornecedorImportUpload'
import ActionFollowUpRevisaoUpload from './Action/Upload/FollowUpRevisaoUpload'
import ActionMrpDistributionUpload from './Action/Upload/MrpDistribution'
import ActionMrpPurchaseUpload from './Action/Upload/MrpPurchase'
import ActionParametrizationIncrementSupplyUpload from './Action/Upload/ParametrizationIncrementSupplier'
import ActionParametrizationProductSimilarUpload from './Action/Upload/ParametrizationProductSimilarUpload'
import ActionParametrizationSupplyUpload from './Action/Upload/ParametrizationSupply'
import ActionParametrizationReabTypeOfVeichuleUpload from './Action/Upload/ReabTypeofVeichuleUpload'
import ActionUserUpload from './Action/Upload/UserUpload'
import LayoutToolsButton from './Components/Button'

interface ILayoutToolsActions {
  onClick?: () => void
  disableActionsByDefault?: (columnId: string) => boolean
}

const LayoutToolsActions: FC<ILayoutToolsActions> = ({
  onClick,
  disableActionsByDefault
}) => {
  const { actions } = useTools()

  return (
    <HStack spacing={1}>
      {actions!.map((action, index) => {
        if (action.type === 'button') {
          return (
            <LayoutToolsButton
              key={`toolbar-action-${index}`}
              label={action.label ?? ''}
              onClick={action.onClick}
            />
          )
        }

        if (action.type === 'columns') {
          return (
            <ActionColumns
              key={`toolbar-action-${index}`}
              data={action.data!}
              onChange={action.onToggleColumn!}
              disableActionsByDefault={disableActionsByDefault}
            />
          )
        }

        if (action.type === 'export') {
          return (
            <ActionExport
              onClick={onClick}
              key={`toolbar-action-${index}`}
              exports={action.exports!}
            />
          )
        }

        if (action.type === 'cronogramaUpload') {
          return <ActionCronogramaUpload key={`toolbar-action-${index}`} />
        }

        if (action.type === 'purchaseFeriasCarga') {
          return <ActionFeriasCargaUpload key={`toolbar-action-${index}`} />
        }

        if (action.type === 'userUpload') {
          return <ActionUserUpload key={`toolbar-action-${index}`} />
        }

        if (action.type === 'purchaseUpload') {
          return <ActionMrpPurchaseUpload key={`toolbar-action-${index}`} />
        }

        if (action.type === 'distributionUpload') {
          return <ActionMrpDistributionUpload key={`toolbar-action-${index}`} />
        }
        if (action.type === 'parametrizationSupplyUpload') {
          return (
            <ActionParametrizationSupplyUpload
              key={`toolbar-action-${index}`}
            />
          )
        }

        if (action.type === 'followUploadComment') {
          return <ActionFollowUpComentUpload key={`toolbar-action-${index}`} />
        }

        if (action.type === 'followUpRevisaoUpload') {
          return <ActionFollowUpRevisaoUpload key={`toolbar-action-${index}`} />
        }

        if (action.type === 'followUpFornecedorImportUpload') {
          return (
            <ActionFollowUpFornecedorImportUpload
              key={`toolbar-action-${index}`}
            />
          )
        }

        if (action.type === 'followUpFornecedorExport') {
          return (
            <ActionFollowUpFornecedorExport key={`toolbar-action-${index}`} />
          )
        }

        if (action.type === 'followUploadReabComment') {
          return (
            <ActionFollowUpComentReabUpload key={`toolbar-action-${index}`} />
          )
        }

        if (action.type === 'parametrizationReabTypeVeichuleUpload') {
          return (
            <ActionParametrizationReabTypeOfVeichuleUpload
              key={`toolbar-action-${index}`}
            />
          )
        }
        if (action.type === 'parametrizationProcuctSimilarUpload') {
          return (
            <ActionParametrizationProductSimilarUpload
              key={`toolbar-action-${index}`}
            />
          )
        }
        if (action.type === 'parametrizationIncrementSupplyUpload') {
          return (
            <ActionParametrizationIncrementSupplyUpload
              key={`toolbar-action-${index}`}
            />
          )
        }
        if (
          action.type === 'purchaseSuppliers' ||
          action.type === 'purchaseSuppliersProgrammed'
        ) {
          return (
            <ActionPurchaseSuppliers
              key={`toolbar-action-${index}`}
              data={action.data!}
              onUpdate={action.onUpdate}
              isScheduled={action.type === 'purchaseSuppliersProgrammed'}
            />
          )
        }
        if (action.type === 'sapHistoricPurchase') {
          return (
            <ActionSapHistoric key={`toolbar-action-${index}`} code={'103'} />
          )
        }
        if (action.type === 'sapHistoricPurchaseSchedul') {
          return (
            <ActionSapHistoric key={`toolbar-action-${index}`} code={'108'} />
          )
        }
        if (action.type === 'sapHistoricDistribuition') {
          return (
            <ActionSapHistoric key={`toolbar-action-${index}`} code={'105'} />
          )
        }
        if (action.type === 'sapHistoricReab') {
          return (
            <ActionSapHistoric key={`toolbar-action-${index}`} code={'102'} />
          )
        }
        if (action.type === 'purchaseSuppliers-createOrder') {
          return (
            <ActionPurchaseCreateOrderSap
              key={`toolbar-action-${index}`}
              data={action.data!}
              onUpdate={action.onUpdate}
              isScheduled={false}
            />
          )
        }
        if (action.type === 'purchaseSuppliers-createOrder-schedule') {
          return (
            <ActionPurchaseCreateOrderSapSchedule
              key={`toolbar-action-${index}`}
              data={action.data!}
              onUpdate={action.onUpdate}
              isScheduled={false}
            />
          )
        }
        if (action.type === 'purchaseSuppliers-createOrder-distribuition') {
          return (
            <ActionPurchaseCreateOrderSapDistribuition
              key={`toolbar-action-${index}`}
              data={action.data!}
              onUpdate={action.onUpdate}
              isScheduled={false}
            />
          )
        }
        if (action.type === 'purchaseSuppliers-createOrder-reab') {
          return (
            <ActionPurchaseCreateOrderSapReab
              key={`toolbar-action-${index}`}
              data={action.data!}
              onUpdate={action.onUpdate}
              isScheduled={false}
            />
          )
        }

        if (action.type === 'reabTimelineHistoric') {
          return <ModalHistoricReabTimeline key={`toolbar-action-${index}`} />
        }
        if (action.type === 'reabTypeVeichuleHistoric') {
          return <ModalHistoricTypeVeichule key={`toolbar-action-${index}`} />
        }

        if (action.type === 'reabRouteHistoric') {
          return <ModalHistoricRouteReab key={`toolbar-action-${index}`} />
        }

        if (action.type === 'purchaseCronogramaHistoric') {
          return (
            <ModalHistoricPurchaseCronograma key={`toolbar-action-${index}`} />
          )
        }

        if (action.type === 'purchaseUserHistoric') {
          return <ModalHistoricPurchaseUser key={`toolbar-action-${index}`} />
        }

        if (action.type === 'purchaseAlcadasHistoric') {
          return (
            <ModalHistoricPurchaseAlcadas key={`toolbar-action-${index}`} />
          )
        }

        if (action.type === 'purchaseToleranciaHistoric') {
          return (
            <ModalHistoricPurchaseTolerancia key={`toolbar-action-${index}`} />
          )
        }

        if (action.type === 'purchaseFeriasHistoric') {
          return <ModalHistoricPurchaseFerias key={`toolbar-action-${index}`} />
        }

        if (action.type === 'followUpFornecedorConfigHistoric') {
          return (
            <ModalHistoricoConfigFollowUp key={`toolbar-action-${index}`} />
          )
        }

        return null
      })}
    </HStack>
  )
}

export default LayoutToolsActions
